import React, { useEffect, useState } from 'react';

import './Tabs.scss';

const RenderTabs = ({ tabs, activeTabId, onSelect }) => (
  <>
    {tabs.map(({ id, title, ...properties }) => (
      <div
        className={`avt-react-components--tab ${id === activeTabId ? 'active' : ''}`}
        key={id}
        id={id}
        onClick={() => onSelect(id)}
        {...properties}
      >
        {title}
      </div>
    ))}
  </>
);

const Tabs = ({ children, onTabChange, defaultSelected, selectedTab, actions, ...properties }) => {
  const tabs = React.Children.toArray(children).map(({ props: tabProperties }) => tabProperties);
  const [activeTabId, setActiveTabId] = useState(
    defaultSelected || (tabs.length > 0 && tabs[0].id)
  );

  useEffect(() => {
    if (selectedTab) {
      setActiveTabId(selectedTab);
    }
  }, [selectedTab]);

  const activeTab = tabs.find(({ id }) => id === activeTabId);

  const onSelect = (id) => {
    setActiveTabId(id);
    if (typeof onTabChange === 'function') {
      onTabChange(id);
    }
  };

  return (
    <>
      <div
        className="avt-react-components--tabs"
        {...properties}
      >
        <RenderTabs
          tabs={tabs}
          activeTabId={activeTabId}
          onSelect={onSelect}
        />
        {actions !== undefined && <div className="avt-react-components--action">{actions}</div>}
      </div>
      {activeTab !== undefined && activeTab.children}
    </>
  );
};

export const Tab = ({ id, title, children, ...properties }) => (
  <div
    id={id}
    {...properties}
  >
    {children}
  </div>
);

export default Tabs;
